module.exports = __webpack_public_path__ + "img/diverse_fiction.8270991e.svg";